var map = {
	"./cateicon0.svg": "1106",
	"./cateicon0_a.svg": "f035",
	"./cateicon1.svg": "cc55",
	"./cateicon1_a.svg": "2646",
	"./cateicon2.svg": "31a5",
	"./cateicon2_a.svg": "12ab",
	"./cateicon3.svg": "81d6",
	"./cateicon3_a.svg": "8fea",
	"./cateicon4.svg": "9aa4",
	"./cateicon4_a.svg": "e876",
	"./cateicon5.svg": "ee4f",
	"./cateicon5_a.svg": "944f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ffe";